<template>
  <div>
    <el-date-picker v-model="childValue" class="h-40 mw-240 w-100p" type="datetime" :placeholder="placeholder" :picker-options="pickerOptions" :disabled="disabled" @input="change" v-if="!isRange"></el-date-picker>
    <el-date-picker v-model="childValue" class="h-40 mw-240 w-100p" type="datetimerange" :placeholder="placeholder" :picker-options="pickerOptions" :disabled="disabled" @input="change" v-else></el-date-picker>
  </div>
</template>
<script>
  /**
   * @param Number value 绑定值（时间戳）
   * @param String name 控件名
   * @param Boolean disabled 是否禁用
   * @param Array rules 表单验证规则
   * @param Object config 配置值
   * @param String placeholder 提示语
   * @param Boolean isRange 是否范围
   */
  // 输入：时间戳（秒）；转换为：Date对象；输出：时间戳（秒）
  import modelConfig from '../../../../config/modelConfig'
  import _verify from '../../../../assets/js/verify'
  export default {
    props: ['value', 'name', 'disabled', 'rules', 'config', 'placeholder', 'isRange'],
    data() {
      return {
        COMPONENT_NAME: 'honrayDatetime',
        childValue: null,
        pickerOptions: {}
      }
    },
    created() {
      this.initData()
      this.init()
    },
    methods: {
      initData() {
        if (this.value) {
          this.childValue = this.parseDate(this.value)
        } else if (this.value == null) {
          this.setDefaultValue()
        } else {
          if (this.isRange) {
            this.childValue = []
          } else {
            this.childValue = ''
          }
        }
      },
      init() {
        this.setSelectRange()
        this.setQuickConfig()
      },
      setDefaultValue() { // 设置默认值
        if (!this.config.date_default.is_null) { // 有设置默认值
          if (!this.isRange) { // 非日期范围
            this.childValue = this.parseFormula(this.config.date_default.single)
          } else { // 是日期范围
            let defaultRange = []
            let defaultStart = this.parseFormula(this.config.date_default.range_start)
            let defaultEnd = this.parseFormula(this.config.date_default.range_end)
            if (defaultStart) {
              defaultRange.push(defaultStart)
            } else {
              defaultRange.push(new Date())
            }
            if (defaultEnd) {
              defaultRange.push(defaultEnd)
            } else {
              defaultRange.push(new Date())
            }
            this.childValue = defaultRange
          }
        } else {
          if (this.isRange) {
            this.childValue = []
          } else {
            this.childValue = ''
          }
        }
        this.change(this.childValue)
      },
      setSelectRange() { // 设置可选范围
        let datetimeMin = null
        let datetimeMax = null
        if (this.config.date_min.type == this.DATE_LIMIT_VAR) { // 最小值类型为变量公式
          datetimeMin = this.parseFormula(this.config.date_min.var_limit)
        } else if (this.config.date_min.type == this.DATE_LIMIT_FIXED) { // 最小值类型为固定值
          datetimeMin = new Date(this.config.date_min.fixed_value)
        }
        if (this.config.date_max.type == this.DATE_LIMIT_VAR) { // 最大值类型为变量公式
          datetimeMax = this.parseFormula(this.config.date_max.var_limit)
        } else if (this.config.date_max.type == this.DATE_LIMIT_FIXED) { // 最大值类型为固定值
          datetimeMax = new Date(this.config.date_max.fixed_value)
        }
        if (datetimeMin && datetimeMax) { // 最大最小值都有
          this.pickerOptions = {
            disabledDate(time) {
              return !(time.getTime() >= (datetimeMin.getTime() + 86400000) && time.getTime() <= (datetimeMax.getTime() + 86400000))
            }
          }
        } else if (datetimeMin) { // 只有最小值
          this.pickerOptions = {
            disabledDate(time) {
              return !(time.getTime() >= datetimeMin.getTime() + 86400000)
            }
          }
        } else if (datetimeMax) { // 只有最大值
          this.pickerOptions = {
            disabledDate(time) {
              return !(time.getTime() <= datetimeMax.getTime() + 86400000)
            }
          }
        }
      },
      setQuickConfig() { // 设置快捷选项
        if (this.config.quick_config && this.config.quick_config.length) {
          let shortcuts = []
          _(this.config.quick_config).forEach((res) => {
            if (!this.isRange && res.single) { // 单日期
              let parseResult = this.parseFormula(res.single)
              if (parseResult) { // 若配置公式可解析出正确日期
                shortcuts.push({
                  text: res.name,
                  onClick(picker) {
                    picker.$emit('pick', parseResult)
                  }
                })
              }
            } else if (this.isRange && res.start && res.end) { // 日期范围
              let parseStart = this.parseFormula(res.start)
              let parseEnd = this.parseFormula(res.end)
              if (parseStart && parseEnd) { // 若配置公式可解析出正确日期
                shortcuts.push({
                  text: res.name,
                  onClick(picker) {
                    picker.$emit('pick', [parseStart, parseEnd])
                  }
                })
              }
            }
          })
          if (shortcuts.length) {
            this.pickerOptions.shortcuts = shortcuts
          }
        }
      },
      parseFormula(value) { // 解析公式
        if (value) {
          let valueTrim = value.trim().replace(/\s/g, '') // 去空格
          let formulaArr = valueTrim.split('&')
          let date = new Date()
          let str = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
          let result = moment(new Date(str))
          _(formulaArr).forEach((formula) => {
            let hasPlus = formula.indexOf('+') > -1
            let hasMinus = formula.indexOf('-') > -1
            let unit = ''
            if (formula.indexOf('Y') > -1) { // 年
              unit = 'years'
            } else if (formula.indexOf('M') > -1) { // 月
              unit = 'months'
            } else if (formula.indexOf('D') > -1) { // 日
              unit = 'days'
            } else if (formula.indexOf('h') > -1) { // 时
              unit = 'hours'
            } else if (formula.indexOf('m') > -1) { // 分
              unit = 'minutes'
            } else if (formula.indexOf('s') > -1) { // 秒
              unit = 'seconds'
            }
            if (unit) {
              let splitResult = ''
              let number = 0
              let times = 1
              if (hasPlus) {
                splitResult = formula.split('+')
                times = 1
              } else if (hasMinus) {
                splitResult = formula.split('-')
                times = -1
              }
              if (hasPlus || hasMinus) {
                _(splitResult).forEach((res) => { // 遍历切割的数组，把数字减掉
                  if ((/^[0-9\.]+$/g).test(res)) {
                    number += parseFloat(res) * times
                    if (unit === 'days') {
                      number--
                    }
                  }
                })
              }
              result.add(number, unit)
            }
          })
          return new Date(result)
        } else {
          return ''
        }
      },
      parseDate(value) {
        let outputValue = ''
        // if (value.indexOf(' to ') > -1) { // 范围
        //   outputValue = value.split(' to ')
        //   let outputStart = new Date(outputValue[0])
        //   let outputEnd = new Date(outputValue[1])
        //   if (this.isTypeDate(outputStart) && this.isTypeDate(outputEnd)) {
        //     return [outputStart, outputEnd]
        //   } else {
        //     return []
        //   }
        // }
        outputValue = new Date(value * 1000)
        if (this.isTypeDate(outputValue)) {
          return outputValue
        } else {
          return ''
        }
      },
      isTypeDate (value) {
        return typeof value == 'object' && value.getDate
      },
      change(value) {
        let outputValue = ''
        if (value || value.length) {
          if (this.isRange) {
            outputValue = `${moment(value[0]).format('YYYY-MM-DD HH:mm:ss')} to ${moment(value[1]).format('YYYY-MM-DD HH:mm:ss')}`
          } else {
            outputValue = moment(value).unix()
          }
        }
        this.$emit('input', outputValue)
      }
    },
    watch: {
      'value'() {
        if (this.value != this.childValue) {
          this.initData()
        }
      }
    },
    mixins: [modelConfig]
  }
</script>



// WEBPACK FOOTER //
// honrayDatetime.vue?8cc4ad3e